import { FC, Fragment } from 'react';

import { UseNotificationCenter } from 'react-toastify/addons/use-notification-center';
import { Button } from 'reactstrap';

import classNames from 'classnames';

import { Toggle } from '@hsp/react-component-library';

import { INotification } from '@c/notifications/types';

import { s } from 'utilities/strings';

import { NotificationEmpty, NotificationItem } from './components';
import { useNotificationPanelConfiguration } from './hooks';

import cssClass from './notification-center-panel.module.scss';

const NotificationCenterPanel: FC<UseNotificationCenter<INotification>> = (props) => {
  const {
    handleClear,
    handleMarkAllAsRead,
    handleMarkAsRead,
    handleRemove,
    handleToggleUnreadOnly,
    isEmpty,
    showUnreadOnly,
    visible,
  } = useNotificationPanelConfiguration(props);

  return (
    <div className={cssClass.notificationCenterPanel}>
      <div className={cssClass.notificationCenterPanelHeader}>
        <div>{s('Site.NotificationCenter.Notification', { plural: true })}</div>
        <Toggle
          checked={showUnreadOnly}
          className={classNames(cssClass.toggleWrapper)}
          label={s(['Site.NotificationCenter.Unread'])}
          labelPlacement="left"
          onToggle={handleToggleUnreadOnly}
        />
      </div>
      <div className={cssClass.notificationCenterPanelBody}>
        <Fragment>
          <NotificationEmpty show={isEmpty} />
          {visible.map((notification) => {
            return (
              <NotificationItem
                key={notification.id}
                notification={notification}
                onMarkAsRead={handleMarkAsRead}
                onRemove={handleRemove}
              />
            );
          })}
        </Fragment>
      </div>
      <div className={cssClass.notificationCenterPanelFooter}>
        <Button
          color="light"
          onClick={handleClear}
          size="sm"
          type="button">
          {s(['Site.Delete', 'Site.All'])}
        </Button>
        <Button
          color="light"
          onClick={handleMarkAllAsRead}
          size="sm"
          type="button">
          {s(['Site.NotificationCenter.AsRead'])}
        </Button>
      </div>
    </div>
  );
};

export default NotificationCenterPanel;
